import { render, staticRenderFns } from "./Confessions.vue?vue&type=template&id=3eeb7a0a&"
import script from "./Confessions.vue?vue&type=script&lang=js&"
export * from "./Confessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports